import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import BaseDetails from 'containers/Base/BaseDetails';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
  closeDetails,
  getCurrentPage,
  openDetails,
  toggleConfirmPopup,
} from 'reducers/ui';

import { tripPageActions, tripActions } from 'containers/Pages/Tasks/Trips';
import { BASE_TRIP_STATUS } from 'utils/constants/transport';
import API from 'services/api';
import { transformRaw } from 'utils/DataTransform/Personnel/PersonnelList';
import { loginStatus } from 'utils/constants/status';
import OperationalAction from 'components/Operational/operationalAction';
import {
  getTripDetailsTransformed,
  getSelectedRowID,
} from 'containers/Pages/Tasks/Trips/Selectors/tripSelectors';
import { serviceTypes } from 'utils/constants/serviceTypes';
import styles from 'containers/Pages/Tasks/Emergencies/Layouts/index.module.scss';
import Button from 'components/Button';
const allowedDriverStatus = [
  loginStatus.AVAILABLE,
  loginStatus.ON_INTERRUPTABLE_TASK,
];
const TripDetails = ({
  id,
  cancel,
  downloadable,
  cancelTripPopUp,
  tripIsResolved,
}) => {
  const [selectedDriver, setSelectedDriver] = useState(null);
  const downloadButtonClick = () => {
    dispatchPrintTripDetails(id);
  };
  //------------------------------Selectors---------------------------------
  const details = useSelector(state => getTripDetailsTransformed(state));
  const pageUrl = useSelector(state => getCurrentPage(state));
  const tripId = useSelector(state => getSelectedRowID(state));
  //-----------------------Actions------------------------------------------
  const dispatch = useDispatch();
  const dispatchFetchTripDetails = useCallback(
    id => dispatch(tripActions.fetchGridRowDetails({ id })),
    [dispatch],
  );
  const dispatchOpenDetails = useCallback(url => dispatch(openDetails(url)), [
    dispatch,
  ]);
  const dispatchCancelTrip = useCallback(
    id => dispatch(tripPageActions.cancelTrip({ id })),
    [dispatch],
  );
  const dispatchAssignDriver = useCallback(
    ({ id, driver }) => {
      dispatch(
        tripPageActions.assignDriver({
          id: id,
          driver: driver,
        }),
      );
    },
    [dispatch],
  );
  const dispatchPrintTripDetails = useCallback(
    id => {
      dispatch(tripPageActions.printTripDetails({ id }));
    },
    [dispatch],
  );
  const handleCancel = () => {
    dispatchCancelTrip(id);
  };
  const assignDriver = () => {
    if (selectedDriver) {
      dispatchAssignDriver({
        id: id,
        driver: selectedDriver.value,
      });
    }
  };
  const shouldDisableOperations = () => {
    //Cannot assign if the status of the event is Resolved.
    if (!details || Object.keys(details).length === 0 || !details.status) {
      return false;
    }
    if (details.status.value instanceof Array) {
      const hasResolved = details.status.value.find(f => {
        return (
          f.status === BASE_TRIP_STATUS.RESOLVED_ABORTED.id ||
          f.status === BASE_TRIP_STATUS.RESOLVED.id
        );
      });
      return hasResolved && hasResolved.length > 0;
    }
    return false; // nice and easy as the only time it is not an array is when it is new
  };
  const getActionItem = type => {
    switch (type) {
      case 'assign-driver':
        return {
          label: 'Assign Driver',
          placeholder: 'Select a driver',
          selectedValue: selectedDriver,
          changeSelectedValue: setSelectedDriver,
          isDisabled: shouldDisableOperations(),
          btnText: 'Assign',
          btnSize: 's',
          btnClick: assignDriver,
          disabled: !selectedDriver || shouldDisableOperations(),
          btnDisabled: !selectedDriver || shouldDisableOperations(),
          fetchOptions: API.fetchUserList,
          dataTransform: ({ data }) => {
            const transformedDrivers = transformRaw(data);
            return transformedDrivers;
          },
          fetchFilters: {
            status: allowedDriverStatus,
            service: [serviceTypes.transport.standard],
            archived: false,
          },
          optionLabelKey: 'label',
        };
      default:
        return null;
    }
  };
  useEffect(() => {
    dispatchFetchTripDetails(id);
    dispatchOpenDetails(pageUrl);
    return () => {
      dispatch(closeDetails(pageUrl));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatchFetchTripDetails, tripId]);

  const operationalComponent = () => {
    return (
      <div>
        <div>
          <OperationalAction
            type={'asyncDropdown'}
            item={getActionItem('assign-driver')}
          />
        </div>
        <div className={styles.buttonContainer}>
          <Button text="Abort" onClick={handleCancel} />
        </div>
      </div>
    );
  };
  return (
    <BaseDetails
      header="Trip Details"
      details={details}
      cancel={cancel}
      operationComponent={!tripIsResolved && operationalComponent()}
      showConfirmPopup={cancelTripPopUp}
      closeConfirmPopup={toggleConfirmPopup}
      downloadable={downloadable}
      onDownloadClick={downloadButtonClick}
      editable={false}
    />
  );
};
TripDetails.propTypes = {
  id: PropTypes.string,
  cancel: PropTypes.func,
  fetchTripDetail: PropTypes.func,
  tripDetail: PropTypes.object,
  personnel: PropTypes.array,
  assignTrip: PropTypes.func,
  selected: PropTypes.object,
  toggleConfirmPopup: PropTypes.func,
  cancelTripPopUp: PropTypes.bool,
  tripIsResolved: PropTypes.func,
  downloadButtonClick: PropTypes.func,
  downloadable: PropTypes.bool,
};
const mapDispatchToProps = dispatch => ({
  toggleConfirmPopup: () => dispatch(toggleConfirmPopup('cancelTrip')),
});

export default connect(mapDispatchToProps)(TripDetails);
